export default ({ store }) => {
  if (!store.getters['accountBalances/currencyListLoaded']) {
    return store
      .dispatch('accountBalances/loadCurrencyList')
      .catch(() => {})
  }
}
